/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type PostApiSaleBodyDataItemsItemItemType =
    (typeof PostApiSaleBodyDataItemsItemItemType)[keyof typeof PostApiSaleBodyDataItemsItemItemType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiSaleBodyDataItemsItemItemType = {
    SERVICE: 'SERVICE',
    PRODUCT: 'PRODUCT',
    GIFT_CARD: 'GIFT_CARD',
    OUTSTANDING: 'OUTSTANDING',
    CUT_CARD: 'CUT_CARD',
    BONUS: 'BONUS',
} as const;
